import { useFormContext } from "react-hook-form";

import { ReactComponent as SortIcon } from "assets/icons/sort.svg";

interface Props {
  children: string;
  name: string;
  defaultValue?: string;
}

const SortButton = ({ children, name, defaultValue }: Props) => {
  const { getValues, setValue } = useFormContext<{ sort: string }>();

  const onSort = () => {
    const sort = getValues("sort");
    setValue(
      "sort",
      sort
        ? !sort.includes(name) || sort === `${name}Asc`
          ? `${name}Desc`
          : `${name}Asc`
        : !defaultValue || defaultValue.includes(name)
          ? `${name}Asc`
          : `${name}Desc`,
    );
  };

  return (
    <button
      onClick={onSort}
      type="button"
      className="flex items-center mx-auto justify-center gap-1"
    >
      <span>{children}</span>
      <SortIcon className="size-5" />
    </button>
  );
};

export default SortButton;
